// src/components/CenteredContent.js

export default function CenteredContent({ children, maxWidth = true }) {
  return (
    <div className={`${maxWidth ? "max-w-screen-xl" : ""} mx-auto px-[5%]`}>
      {children}
    </div>
  );
}
